var map = {
	"./as_ala.gif": 10606,
	"./as_arg.gif": 37974,
	"./as_asn.gif": 64156,
	"./as_asp.gif": 61806,
	"./as_cys.gif": 56473,
	"./as_gln.gif": 44351,
	"./as_glu.gif": 30512,
	"./as_gly.gif": 8988,
	"./as_hcy.gif": 63870,
	"./as_his.gif": 1606,
	"./as_ile.gif": 90538,
	"./as_leu.gif": 54772,
	"./as_lys.gif": 85826,
	"./as_met.gif": 80208,
	"./as_phe.gif": 47031,
	"./as_pro.gif": 1043,
	"./as_pyl.gif": 90549,
	"./as_sec.gif": 75381,
	"./as_ser.gif": 15532,
	"./as_thr.gif": 53824,
	"./as_trp.gif": 49900,
	"./as_tyr.gif": 85283,
	"./as_val.gif": 76315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78790;